var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import Footer from './components/Footer';
import { Bottom, Copyright, DefaultLinks, Finansportalen, Feedback, Top, Column, Addon, Grid, } from './components';
function init() {
    return __awaiter(this, arguments, void 0, function (id, props) {
        var version, container, App, createRoot, root, render;
        var _a, _b;
        if (id === void 0) { id = 'footer-root'; }
        if (props === void 0) { props = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, import('react/package.json')];
                case 1:
                    version = (_c.sent()).version;
                    container = document.getElementById(id);
                    App = (React.createElement(Footer, null,
                        React.createElement(Feedback, null),
                        React.createElement(Top, null),
                        React.createElement(Bottom, null,
                            props.addons && (React.createElement(Grid, null,
                                React.createElement(Column, null,
                                    React.createElement(DefaultLinks, null),
                                    ((_a = props.show) === null || _a === void 0 ? void 0 : _a.finansportalen) && (React.createElement(Finansportalen, null)),
                                    React.createElement(Copyright, null)),
                                props.addons && (React.createElement(Addon, __assign({}, props.addons))))),
                            !props.addons && (React.createElement(Column, null,
                                React.createElement(DefaultLinks, null),
                                ((_b = props.show) === null || _b === void 0 ? void 0 : _b.finansportalen) && (React.createElement(Finansportalen, null)),
                                React.createElement(Copyright, null))))));
                    if (!version.startsWith('18')) return [3 /*break*/, 3];
                    return [4 /*yield*/, import('react-dom/client')];
                case 2:
                    createRoot = (_c.sent()).createRoot;
                    root = createRoot(container);
                    root.render(App);
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, import('react-dom')];
                case 4:
                    render = (_c.sent()).render;
                    render(App, document.getElementById(id));
                    _c.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
}
export default init;
